import {convertKBtoGo} from "../utils/convertiseur";

const countFilesRecursively = (actif) => {
    let count = 0;
  
    const countFiles = (classeurs) => {
      classeurs.forEach((classeur) => {
        count += classeur.fichiers?.length;
        if (classeur.classeurs) {
          countFiles(classeur.classeurs);
        }
      });
    };
  
    if (actif.classeurs) {
      countFiles(actif.classeurs);
    }
  
    return count;
  };



  const calculateTotalSizeRecursively = (data) => {
    let totalSize = 0;
  
    const calculateSize = (classeurs) => {
      classeurs.forEach((classeur) => {
        classeur.fichiers.forEach((file) => {
          totalSize += file.size;
        });
        if (classeur.classeurs) {
          totalSize += calculateSize(classeur.classeurs);
        }
      });
    };
  
    if (data.classeurs) {
      calculateSize(data.classeurs);
    } 
    return convertKBtoGo(totalSize);
  };
  
  export {countFilesRecursively,calculateTotalSizeRecursively};